module.exports = fox._r("images/chrome.png", __webpack_public_path__ + "_/_/_/common/frame/images/chrome.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/chrome.png
// module id = 156
// module chunks = 2